import cn from 'classnames';

import { LogoMark } from '../Svg/LogoMark';

export function ClientBadge({
  containerSize = 0,
  shape,
}: {
  containerSize?: number;
  shape: 'circle' | 'rounded';
}) {
  const hasContainer = containerSize > 0;
  return (
    <span
      className={cn(
        'flex items-center justify-center bg-yellow-400 text-gray-900',
        {
          'absolute z-10': hasContainer,
          'h-4 w-4': !hasContainer,
          'rounded-full [&>svg]:h-[46.1538461538462%] [&>svg]:w-[46.1538461538462%]':
            shape === 'circle',
        },
        hasContainer && {
          'h-[clamp(14px,25%,26px)] w-[clamp(14px,25%,26px)]':
            containerSize >= 88,
          'h-[clamp(14px,32.5%,26px)] w-[clamp(14px,32.5%,26px)]':
            containerSize < 88,
        },
        hasContainer &&
          shape === 'rounded' && {
            '-bottom-1 -right-1 rounded-[4px] [&>svg]:h-[64.285714285714286%] [&>svg]:w-[64.285714285714286%]':
              containerSize < 88 && containerSize !== 70,
            'bottom-1 right-1 rounded-[8px] [&>svg]:h-[54.5454545454545%] [&>svg]:w-[54.5454545454545%]':
              containerSize === 70,
            'bottom-1.5 right-1.5 rounded-[8px] [&>svg]:h-[54.5454545454545%] [&>svg]:w-[54.5454545454545%]':
              containerSize >= 88,
          },
        hasContainer &&
          shape === 'circle' && {
            '-bottom-0.5 -right-0.5': containerSize <= 32,
            'bottom-0 right-0': containerSize > 32,
          },
      )}
    >
      <LogoMark />
    </span>
  );
}
